import React, { useState } from 'react';
import { auth, provider } from '../firebase';
import { FcGoogle } from 'react-icons/fc';
import { NavLink } from 'react-router-dom';

// SIGN IN COMPONENT
export const SignIn = () => {
  const signInWithGoogle = () => {
    auth.signInWithPopup(provider);
  };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const signInWithEmail = () => {
    auth.signInWithEmailAndPassword(email, password);
  };
  return (
    <section className="sign-in">
      <div className="sign-in__container">
        <div className="sign-in__form">
          <h3 className="sign-in__form--heading">Sign In</h3>
          <h6 className="sign-in__form--subheading">Please Enter your Email and Password!</h6>
          <div className="margin--bottom">
            <input
              className="sign-in__form--input"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email Address"
            />
            <input
              className="sign-in__form--input"
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
            />
          </div>
          <button className="sign-in__form--btn" onClick={signInWithEmail}>
            Sign In!
          </button>
          <button className="sign-in__form--btn" onClick={signInWithGoogle}>
            Sign In With Google <FcGoogle className="sign-in__form--icon" />
          </button>
          <h6 className="sign-in__form--bottom">
            Not a member yet? &nbsp;
            <NavLink to="/signup" className="sign-in__form--link">
              Sign up
            </NavLink>
          </h6>
        </div>
      </div>
    </section>
  );
};
